import {useHistory, useParams} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {SubmitButton} from "components/Button";
import {CircleLoader} from "components/Loader";
import {FormCard} from "components/Form";
import {useDetailJabatan} from "hooks/SuperAdmin/Jabatan";

export function MasterJabatanDetailPage() {
	const history = useHistory();
	const {id} = useParams();
	const {data: detailJabatan, isLoading: loadingFetcing} = useDetailJabatan(id);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar List Jabatan" title="Detail Jabatan">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar List Jabatan"
				title={`Detail Data Jabatan  ${detailJabatan?.data?.name}`}
				onBackButtonClick={() => history.push("/master-jabatan")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-6 col-6">
						<div class="setting-item">
							<label class="setting-label ">Nama Jabatan</label>
							<p className="text-bold text-grey">{detailJabatan?.data?.name}</p>
						</div>
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Ubah Data Ini"
						onClick={() => history.push(`/master-jabatan/edit/${detailJabatan?.data?.id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
}
